import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  surfaces = 'surfaces',
  surface = 'surface',
  surfaceSettings = 'surfaceSettings',
}

enum ExternalRoutesIds {
  experimentationPlatformSurface = 'experimentationPlatformSurface',
}

// root route
export const [surfacesRouteImplRef, surfaceIndexRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.surfaces });

export const rootRouteRef = surfacesRouteImplRef;

// sub-routes within the plugin
export const [surfaceRouteImplRef, surfaceRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.surface,
  parent: rootRouteRef,
  path: '/:id',
});

export const [surfaceSettingsRouteImplRef, surfaceSettingsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.surfaceSettings,
    parent: rootRouteRef,
    path: '/:id/settings',
  });

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformSurfaceRouteRef = createExternalRouteRef({
  id: 'backstage-experimentation-platform-surface',
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  surfaces: surfacesRouteImplRef,
  surface: surfaceRouteImplRef,
  surfaceSettings: surfaceSettingsRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  surfaces: surfaceIndexRouteRef,
  surface: surfaceRouteRef,
  surfaceSettings: surfaceSettingsRouteRef,

  // external routes to other systems
  experimentationPlatformSurface: experimentationPlatformSurfaceRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
